import socketIOClient from 'socket.io-client';

const socket = socketIOClient(window.SOCKET_SERVER_URL);

export default socket;